
import Vue from "vue";
import VModal from "@/components/vModal.vue";

interface TranslationObject {
  get(key: string): string;
  [key: string]: any;
}

export default Vue.extend({
  name: "SessionTimeoutModal",
  components: { VModal },
  props: {
    show: { type: Boolean, required: true },
    countdown: { type: Number, required: false, default: 0 }, // seconds
    translations: {
      type: Object as () => TranslationObject,
      required: false,
      default: () => ({ get: () => "" }),
    },
  },
  computed: {
    formattedCountdown(): string {
      const s = this.countdown || 0;
      const mins = Math.floor(s / 60)
        .toString()
        .padStart(2, "0");
      const secs = Math.floor(s % 60)
        .toString()
        .padStart(2, "0");
      return `${mins}:${secs}`;
    },
    warningMessage(): string {
      const warning = this.getTranslation('session_timeout_warning');
      return this.decodeHtml(warning).replace('{{1}}', this.formattedCountdown);
    },
  },
  methods: {
    getTranslation(key: string): string {
      return this.translations.get?.(key);
    },
    decodeHtml(value: string): string {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = value;
      return textarea.value;
    },
    onStay() {
      this.$emit("stay");
    },
    onSignOut() {
      this.$emit("signout");
    },
  },
});
